var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"v2026-modal-fade"}},[(_vm.open)?_c('div',{staticClass:"v2026-modal-backdrop",style:(_vm.backdropAlign),on:{"mousedown":_vm.onBackdropDown}},[_c('div',{staticClass:"v2026-modal-dialog",style:(_vm.dialogStyle)},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }